import axiosInstance from "../../../core/api/interceptors/axiosInterceptor";

export const fetchDashboardData = async (period = "monthly", dateRange = null) => {
  const params = { period };
  
  // Add date range if provided
  if (dateRange && dateRange.startDate && dateRange.endDate) {
    params.startDate = dateRange.startDate;
    params.endDate = dateRange.endDate;
  }
  
  const response = await axiosInstance.get(`/dashboard`, { params });
  return response.data;
};